//libs
import { BrowserModule } from "@angular/platform-browser";

import { ErrorHandler, NgModule } from "@angular/core";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { InlineSVGModule } from "ng-inline-svg-2";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { IConfig, provideEnvironmentNgxMask } from "ngx-mask";

import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { CookieService } from "ngx-cookie-service";

// angular modules
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";

//custom modules
import { AppRoutingModule } from "src/app/app-routing.module";
// import { LoginModule } from 'src/app/login/login.module';
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { LeafletMarkerClusterModule } from "@asymmetrik/ngx-leaflet-markercluster";
import { JoyrideModule } from "ngx-joyride";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { TokenInterceptor } from "src/app/core/auth.interceptor";
import { RegisterModule } from "src/app/register/register.module";
import { SharedModule } from "src/app/shared/shared.module";

//components
import { AppComponent } from "src/app/app.component";
import { GlobalErrorHandler } from "src/app/core/error-handler";
import { LayoutComponent } from "src/app/layout/layout.component";

//export const maskOptions: Partial<IConfig> | (() => Partial<IConfig>);

export const maskOptions: Partial<IConfig> | (() => Partial<IConfig>) = {};

registerLocaleData(localeFr, "fr");

@NgModule({
  declarations: [AppComponent],
  imports: [
    LayoutComponent,
    RouterModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      enableSourceMaps: false,
      disableFileDetails: true, //TRACE|DEBUG|INFO|LOG|WARN|ERROR|FATAL|OFF
      colorScheme: ["silver", "gray", "blue", "navy", "fuchsia", "red", "red"],
    }),
    JoyrideModule.forRoot(),
    LeafletModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // LoginModule,
    // OnboardingModule,
    RegisterModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    InlineSVGModule.forRoot(),
    LeafletMarkerClusterModule,
    MatNativeDateModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    CookieService,
    provideEnvironmentNgxMask(maskOptions),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
